import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { WpService } from '../service/wp.service'

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.scss']
})
export class PostComponent implements OnInit {

  post: any;
  loaded: boolean;

  constructor(private wp: WpService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.post = undefined;
    this.loaded = false;
    this.route.params.subscribe(data => {
      this.wp.get('blog/' + data.name).subscribe(
        data => {
          data['post_date'] = new Date(data['post_date'])
          this.post = data

        },
        error => {
          console.error(error)
        }
      )
    })
  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/post/post.component.ts